// eslint-disable-next-line no-undef
const myConfig = config();
const { client: ACTIVE_CLIENT } = myConfig;

export const isFinantechActiveClient = ACTIVE_CLIENT === 'FINANTECH';
export const isStinvestActiveClient = ACTIVE_CLIENT === 'STINVEST';
export const isAureaActiveClient = ACTIVE_CLIENT === 'AUREA';
export const isHemeraActiveClient = ACTIVE_CLIENT === 'HEMERA';
export const isBfacmActiveClient = ACTIVE_CLIENT === 'BFACM';
export const isBpcActiveClient = ACTIVE_CLIENT === 'BPC';
export const isBvalorActiveClient = ACTIVE_CLIENT === 'BVALOR';
